<template>
  <div>
    <!-- Highlights -->
    <HeadlineItem
      class="mt-8"
      :title="item.title"
      :url="item.url"
      :subtitle="item.subtitle"
      :message="item.text"
      :src="item.image"
      @click="clickProduct(item)"
      item="item"
      v-for="(item, index) in hightlight"
      :key="index"
    ></HeadlineItem>
  </div>
</template>
<script>
import { firebase } from "../../main";
import HeadlineItem from "../design/HeadlineItem";

export default {
  data() {
    return {
      hightlight: [],
    };
  },
  methods: {
    clickProduct(item) {
      if (item.hasOwnProperty("url")) {
        window.open(item.url, "_blank");
      }
    },
  },
  mounted() {
    firebase
      .firestore()
      .collection("products")
      .where("highlight", "==", "1")
      .orderBy("sortorder", "desc")
      .limit(3)
      .onSnapshot((docs) => {
        docs.forEach((doc) => {
          this.$set(this.hightlight, this.hightlight.length, doc.data());
        });
      });
  },
  components: {
    HeadlineItem,
  },
};
</script>